import { GameTheory } from './GameTheory';
import { extractYoutubeData } from '../js/classes/Helpers';

window.addEventListener('load', () => {
  if ('scrollRestoration' in history) {
    history.scrollRestoration = 'manual';
  }
  window.scrollTo(0, 0);
});

document.addEventListener('DOMContentLoaded', () => {
  extractYoutubeData();
  new GameTheory();
});
